import React from 'react'

import { useSession } from '@rewardops/auth'
import { Spinner, useLocale } from '@rewardops/ui'

import { EarningHistory } from '../elp-dashboard/sections'
import { useApi } from '../hooks/use-api'

type WidgetContianerProps = {
  content?: any
  contentId?: string
}

export const WidgetContainer: React.FC<WidgetContianerProps> = ({
  content,
  contentId = '',
}: WidgetContianerProps) => {
  const { data: session, isLoading: sessionLoading } = useSession()
  const { api } = useApi()
  const { locale } = useLocale()

  const { data: widgetContent, isLoading } = api.contentful.getById.useQuery(
    {
      language: locale,
      key: contentId,
      type: 'widget',
    },
    {
      enabled: Boolean(contentId),
    },
  )

  const contentLoading = Boolean(contentId) && isLoading

  if (sessionLoading || contentLoading) {
    return <Spinner />
  }

  // widgets will only be shown to logged in members for now
  if (!session || (!content && !widgetContent)) {
    return null
  }

  return (
    <div className="col-span-2 mx-auto mb-[100px] w-full max-w-[1140px] px-4 md:px-0">
      <EarningHistory content={widgetContent ?? content} data={{}} />
    </div>
  )
}
